module.exports = __webpack_public_path__ + "media/payment_options/visa-f3dcd1db.png";